import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigServerService, CustomHttp } from '../../../../core';
import { ClienteAnaliseMercadoFilter } from '../../adapters';
import { ClienteAnaliseMercadoRAPClienteResponse, ClienteAnaliseMercadoRAPResponse, ClienteAnaliseMercadoRAPSaveRequest, ClienteAnaliseMercadoRAPSaveResponse, ClienteAnaliseMercadoRAPOrderBy } from '../adapters';
import { CLIENTES_ANALISES_MERCADOS_RAP_API_RESOURCE } from '../consts';
import { ClienteAnaliseMercadoRAPOptionService } from './cliente-analise-mercado-rap-options.service';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoRAPHttpService {
    private readonly pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp,
                private clienteAnaliseMercadoRAPOptionService: ClienteAnaliseMercadoRAPOptionService) {
        this.pathApi = `${configServerService.getPathApi()}/${CLIENTES_ANALISES_MERCADOS_RAP_API_RESOURCE}`;
    }

    /** Realiza a consulta da Análise de Mercado RAP */
    search(filter: ClienteAnaliseMercadoFilter, orderBy: ClienteAnaliseMercadoRAPOrderBy, limit: number, offset: number): Observable<ClienteAnaliseMercadoRAPResponse> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        // Order By
        if (orderBy) {
            params = params.append('orderBy', orderBy.column ? orderBy.column.toString() : null);
            params = params.append('orderByDir', orderBy.dir ? orderBy.dir : null);
        }

        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<ClienteAnaliseMercadoRAPResponse>(this.pathApi, {params})
                    .pipe(
                        map(response => {
                            if (!response) {
                                return response;
                            }

                            const res = ClienteAnaliseMercadoRAPResponse.fromJSON(JSON.stringify(response));
                            // Clientes
                            res.clientes?.forEach(cliente => {
                                cliente.options = this.clienteAnaliseMercadoRAPOptionService.createClienteOptions(cliente);
                            });

                            return res;
                        })
                    );
    }

    /** Carrega a Análise de Mercado de um cliente */
    searchOneCliente(idCliente: number, filter: ClienteAnaliseMercadoFilter): Observable<ClienteAnaliseMercadoRAPClienteResponse> {
        // Params
        let params = new HttpParams();
        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<ClienteAnaliseMercadoRAPClienteResponse>(`${this.pathApi}/clientes/${idCliente}`, {params})
                    .pipe(
                        map(response => {
                            if (!response) {
                                return response;
                            }

                            const res = ClienteAnaliseMercadoRAPClienteResponse.fromJSON(JSON.stringify(response));
                            res.options = this.clienteAnaliseMercadoRAPOptionService.createClienteOptions(res);
                            return res;
                        })
                    );
    }

    /** Salva uma Análise de Mercado RAP */
    save(request: ClienteAnaliseMercadoRAPSaveRequest): Observable<ClienteAnaliseMercadoRAPSaveResponse> {
        return this.customHttp.put<ClienteAnaliseMercadoRAPSaveResponse>(this.pathApi, request);
    }
}
